<template>
  <header class="h-[73px] bg-white py-3.5 lg:h-[90px] lg:py-4">
    <Container class="flex h-full items-center justify-between md:w-[80%] md:!px-9 lg:w-full">
      <HeaderLogo :theme="theme" :home-url="homeUrl" />
    </Container>
  </header>
</template>

<script setup lang="ts">
import { Container, THEMES } from 'refresh-ui'
import HeaderLogo from './HeaderLogo.vue'

withDefaults(
  defineProps<{
    theme?: THEMES
    homeUrl?: string
  }>(),
  {
    theme: THEMES.DEFAULT,
    homeUrl: '',
  },
)
</script>
